import { render, staticRenderFns } from "./TaxSlab.vue?vue&type=template&id=bb0754c8&scoped=true"
import script from "./TaxSlab.vue?vue&type=script&lang=js"
export * from "./TaxSlab.vue?vue&type=script&lang=js"
import style0 from "./TaxSlab.vue?vue&type=style&index=0&id=bb0754c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0754c8",
  null
  
)

export default component.exports